import React from 'react';
import { FacebookIcon } from 'lucide-react';
import { IMAGES } from '../../data/images';
import { SITE } from '../../data/site';
import { ImageSlot } from '../ui/ImageSlot';
import { ButtonLink } from '../ui/ButtonLink';
export function WomensBand() {
  return <section className="grid bg-ink lg:grid-cols-2" aria-labelledby="women-title" data-id="element-312" data-mp="2x5mmwlml1pjx">
      <ImageSlot image={IMAGES.women} className="min-h-[22rem] lg:min-h-[44rem]" data-id="element-313" data-mp="2s6t5wj837gf0" />
      <div className="gutter flex flex-col justify-center py-[clamp(3.5rem,7vw,8rem)] lg:pl-[clamp(2rem,5vw,8rem)]" data-id="element-314" data-mp="2n76r45cm1s43">
        <p className="font-display text-sm font-medium uppercase tracking-[0.16em] text-chrome-300" data-id="element-315" data-mp="2icsslu2nj4v7">Women’s Defense Network</p>
        <h2 id="women-title" className="t-h2 mt-4 max-w-[18ch] text-white" data-id="element-316" data-mp="29eh5i20zup7i">
          Train in an environment where you feel most comfortable.
        </h2>
        <span className="red-rule mt-6" aria-hidden="true" data-id="element-317" data-mp="24ekxzst38fn7" />
        <p className="t-lead mt-6 max-w-[40rem] text-chrome-100" data-id="element-318" data-mp="1zfrm24tg8wp5">
          Women-only classes, taught by women, since 2013. From your first CCW to advanced defensive handgun — plus the Women’s Defense Network’s monthly clinics to keep your skills sharp alongside women who train like you.
        </p>
        <div className="mt-9 flex flex-wrap gap-3" data-id="element-319" data-mp="25ckba66lclom">
          <ButtonLink to="/womens-training" size="lg" data-id="element-320" data-mp="259ofaneb072t">
            Explore Women’s Training
          </ButtonLink>
          <ButtonLink href={SITE.social.womensDefenseNetwork} size="lg" variant="outline-light" data-id="element-321" data-mp="2y0ggy0e51nxj">
            <FacebookIcon className="h-4 w-4" aria-hidden="true" data-id="element-322" data-mp="3221or7btfc0v" /> Join the Network
          </ButtonLink>
        </div>
      </div>
    </section>;
}